<template>
    <rkm-area
        background-color="danger"
        header-prefix-text="S"
        title="Subjetivo"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-text-editor
                    :validations="validations.descricao"
                    name="Descrição"
                    placeholder="Insira as impressões subjetivas do profissional e as expressadas pelo paciente."
                    v-model="data.model.descricao"
                />
            </rkm-col>
        </rkm-row>

        <BoxMotivoAtendimento
            v-if="!data.additionals.isAtendimentoSaudeBucal"
            :data="data"
        />
    </rkm-area>
</template>

<script>
// Components.
import BoxMotivoAtendimento from './components/motivo-atendimento/Index'

export default {
    components: {BoxMotivoAtendimento},
    computed: {
        validations() {
            return {
                descricao: {max: 5000},
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>